export default "__VITE_ASSET__Cfw7uuc2__"